<script>
    import { onMount } from "svelte";

    export let id;
    onMount(() => {
        init(document, window, "Chatra");
    });
    function init(d, w, c) {
        w.ChatraID = id;
        var s = d.createElement("script");
        w[c] =
            w[c] ||
            function () {
                (w[c].q = w[c].q || []).push(arguments);
            };
        s.async = true;
        s.src = "https://call.chatra.io/chatra.js";
        if (d.head) d.head.appendChild(s);
    }
</script>
